import React, { useRef, useState } from "react";
import { Button, Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DescriptionIcon from "@mui/icons-material/Description";
import ReactToPrint from "react-to-print";
import PrintIcon from "@mui/icons-material/Print";
import NocMemoChallanPopup from "../../../citizen/PaymentChallan/NocMemoChallanPopup";

const NocMemoChallan = ({ nocPaymentDetails }) => {
  const [open, setOpen] = useState(false);
  const componentPDF = useRef();

  return (
    <React.Fragment>
      <Button variant="contained" onClick={() => setOpen(true)}>
        <DescriptionIcon fontSize="small" />
      </Button>

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: {
            position: "fixed",
            top: "10%",
            left: "55%",
            transform: "translateX(-50%)",
            backgroundColor: "#f3f4f6",
            border: "1px solid #ccc",
            padding: "20px",
            zIndex: 1000,
            maxHeight: "80vh",
            overflowY: "auto",
            width: "75%",
          },
        }}
      >
        <DialogTitle
          sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
        >
          NOC Challan
          <div style={{ display: "flex", gap: "10px" }}>
            <ReactToPrint trigger={() => <PrintIcon />} content={() => componentPDF.current} />
            <IconButton onClick={() => setOpen(false)} size="small">
              <CloseIcon />
            </IconButton>
          </div>
        </DialogTitle>

        <DialogContent dividers>
          <div ref={componentPDF}>
            <NocMemoChallanPopup nocPaymentDetails={nocPaymentDetails} />
          </div>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
};

export default NocMemoChallan;
